import styled from '@emotion/styled';
import { getColor } from '../../../common/UICommon';
import { TabletWidth } from '../../../../global.style';

export const JourneySectionWrapper = styled.div`
  position: relative;
  z-index: 1;
`;

export const JourneyEggBg = styled.img`
  position: absolute;
  z-index: 0;
  left: 0px;
  top: -90px;

  @media (max-width: ${TabletWidth}px) {
    display: none;
  }
`;

export const JourneySectionContentWrapper = styled.div`
  max-width: 1120px;
  margin: auto;
  padding: 0px 80px;
  border-bottom: 1px solid ${getColor('GRAY_40')};
  padding-bottom: 145px;

  @media (max-width: ${TabletWidth}px) {
    width: 100%;
    padding: 0px 24px;
    margin-top: 56px;
    padding-bottom: 32px;
    border-bottom: 1px solid ${getColor('GRAY_30')};
  }
`;

export const JourneySectionContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin: auto;

  @media (max-width: ${TabletWidth}px) {
    max-width: 330px;
    flex-direction: column;
  }
`;

export const JourneySectionTextsWrapper = styled.div`
  text-align: left;
  width: 100%;

  @media (max-width: ${TabletWidth}px) {
    text-align: center;
  }
`;

export const JourneySectionImgWrapper = styled.div`
  width: 100%;

  @media (max-width: ${TabletWidth}px) {
    margin-top: 40px;
  }
`;

export const JourneySectionTitle = styled.p`
  font-family: Lora;
  font-size: 28px;
  font-weight: 600;
  line-height: 42px;
  color: ${getColor('GRAY_70')};

  @media (max-width: ${TabletWidth}px) {
    font-size: 24px;
    line-height: 36px;
  }
`;

export const JourneySectionSubtitle = styled.p`
  font-family: Poppins;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  margin-top: 6px;
  color: ${getColor('GRAY_70')};

  @media (max-width: ${TabletWidth}px) {
    margin-top: 4px;
    font-size: 16px;
  }
`;

export const JourneySectionImg = styled.img`
  width: 100%;
`;
